/* Four thumbnails below the main image; audit revision 2, isolated from Campeggi. */
(() => {
  'use strict';
  if (window.__galeaFourThumbnailsLoaded) return;
  window.__galeaFourThumbnailsLoaded = true;
  const instances = new WeakMap();
  let nextId = 0;
  const initialize = (root = document) => {
    const config = document.querySelector('[data-galea-four-thumbnails-config]');
    if (!config) return;
    const sections = Array.from(root.querySelectorAll('[data-section-type="product"]'));
    if (root.matches?.('[data-section-type="product"]')) sections.unshift(root);
    sections.forEach(section => {
      if (instances.has(section) || section.closest('[data-campeggi-product], .GaleaCampeggiProduct')) return;
      const gallery = section.querySelector('.Product__Gallery');
      const slideshow = gallery?.querySelector('.Product__Slideshow');
      if (!slideshow) return;
      const slides = Array.from(slideshow.querySelectorAll('.Product__SlideItem[data-image-id]'));
      if (slides.length < 2) return;
      let navigation = gallery.querySelector('.Product__SlideshowNav--thumbnails');
      let scroller = navigation?.querySelector('.Product__SlideshowNavScroller');
      const originalNavigation = navigation;
      const originalParent = navigation?.parentNode;
      const originalNextSibling = navigation?.nextSibling;
      const originalNavigationId = navigation?.getAttribute('id');
      // Prefer a bounded Shopify thumbnail over a full-resolution original.
      const thumbnailSource = source => {
        const template = source.getAttribute('data-src');
        if (template?.includes('{width}')) return template.replace(/\{width\}/g, '360');
        const value = source.getAttribute('data-original-src') || source.currentSrc || source.getAttribute('src');
        if (!value) return '';
        try {
          const url = new URL(value, document.baseURI);
          if (url.hostname === 'cdn.shopify.com' || url.pathname.startsWith('/cdn/shop/')) {
            url.searchParams.set('width', '360');
            return url.toString();
          }
        } catch (_) { /* Retain the source if it is not a parseable URL. */ }
        return value;
      };
      // Themes with thumbnails disabled still have the same native image slides.
      if (!navigation || !scroller) {
        navigation = document.createElement('div');
        navigation.className = 'Product__SlideshowNav Product__SlideshowNav--thumbnails';
        scroller = document.createElement('div');
        scroller.className = 'Product__SlideshowNavScroller';
        slides.forEach(slide => {
          const source = slide.querySelector('img');
          if (!source) return;
          const link = document.createElement('a');
          link.className = 'Product__SlideshowNavImage';
          link.href = '#' + slide.id;
          const image = document.createElement('img');
          const thumbnailUrl = thumbnailSource(source);
          if (!thumbnailUrl) return;
          image.src = thumbnailUrl;
          image.decoding = 'async';
          image.alt = source.alt || '';
          image.loading = 'lazy';
          link.appendChild(image);
          scroller.appendChild(link);
        });
        navigation.appendChild(scroller);
      }
      const thumbnails = Array.from(scroller.querySelectorAll('a[href^="#Image"]'));
      if (thumbnails.length < 2) return;
      const oldTabIndexes = new Map(thumbnails.map(link => [link, link.getAttribute('tabindex')]));
      const rail = document.createElement('div');
      rail.className = 'GaleaFourThumbs' + (thumbnails.length <= 4 ? ' GaleaFourThumbs--noOverflow' : '');
      rail.setAttribute('role', 'group');
      rail.setAttribute('aria-label', config.dataset.images || 'Imágenes del producto');
      rail.style.setProperty('--galea-thumb-count', Math.min(4, thumbnails.length));
      const navId = 'GaleaFourThumbs-' + (section.dataset.sectionId || 'product') + '-' + (++nextId);
      navigation.id = navigation.id || navId;
      const arrow = (label, path) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'GaleaFourThumbs__Arrow';
        button.setAttribute('aria-label', label);
        button.setAttribute('aria-controls', navigation.id);
        button.innerHTML = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24"><path d="' + path + '"/></svg>';
        return button;
      };
      const previous = arrow(config.dataset.previous || 'Anterior', 'm14 6-6 6 6 6');
      const next = arrow(config.dataset.next || 'Siguiente', 'm10 6 6 6-6 6');
      rail.append(previous, navigation, next);
      slideshow.insertAdjacentElement('afterend', rail);
      section.setAttribute('data-galea-four-thumbnails', 'true');
      const desktop = window.matchMedia('(min-width: 1008px)');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const cleanups = [];
      let frame = 0;
      let lastId = '';
      let pendingNativeId = null;
      let breakpointFrame = 0;
      let destroyed = false;
      const listen = (target, type, fn, options) => {
        target.addEventListener(type, fn, options);
        cleanups.push(() => target.removeEventListener(type, fn, options));
      };
      const updateArrows = () => {
        previous.disabled = navigation.scrollLeft <= 1;
        next.disabled = navigation.scrollLeft >= navigation.scrollWidth - navigation.clientWidth - 1;
      };
      const step = () => thumbnails[1].offsetLeft - thumbnails[0].offsetLeft;
      const scroll = left => {
        const target = Math.max(0, Math.min(left, navigation.scrollWidth - navigation.clientWidth));
        if (navigation.scrollTo) navigation.scrollTo({left: target, behavior: reduced.matches ? 'auto' : 'smooth'});
        else navigation.scrollLeft = target;
      };
      const reveal = thumbnail => {
        if (!thumbnail) return;
        const left = thumbnail.offsetLeft;
        const right = left + thumbnail.offsetWidth;
        if (left < navigation.scrollLeft) navigation.scrollLeft = left;
        else if (right > navigation.scrollLeft + navigation.clientWidth + 1) navigation.scrollLeft = right - navigation.clientWidth;
      };
      const synchronize = (force = false) => {
        if (destroyed) return;
        if (pendingNativeId && !desktop.matches) {
          const pending = pendingNativeId;
          pendingNativeId = null;
          if (!nativeSelect(pending)) pendingNativeId = pending;
        }
        const active = desktop.matches
          ? slideshow.querySelector('.is-joquer-selected') || slideshow.querySelector('.is-selected')
          : slideshow.querySelector('.is-selected');
        const id = active?.dataset.imageId;
        if (!id) { updateArrows(); return; }
        if (force || id !== lastId) {
          lastId = id;
          thumbnails.forEach(link => {
            const selected = link.hash === '#Image' + id;
            link.classList.toggle('is-selected', selected);
            link.tabIndex = selected ? 0 : -1;
            if (selected) link.setAttribute('aria-current', 'true');
            else link.removeAttribute('aria-current');
          });
          reveal(thumbnails.find(link => link.hash === '#Image' + id));
        }
        updateArrows();
      };
      const queue = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => synchronize());
      };
      const nativeSelect = id => {
        const index = slides.findIndex(slide => slide.dataset.imageId === id);
        if (index < 0) return false;
        const flickity = typeof window.Flickity?.data === 'function' ? window.Flickity.data(slideshow) : null;
        if (flickity) { flickity.select(index, false, reduced.matches); return true; }
        const dot = slideshow.querySelectorAll('.flickity-page-dots .dot')[index];
        if (dot) { dot.click(); return true; }
        return false;
      };
      // Desktop clicks keep the existing decoded-image and variant logic.
      // On small screens, use the native slider rather than an anchor-page jump.
      listen(navigation, 'click', event => {
        if (desktop.matches || !(event.target instanceof Element)) return;
        const link = event.target.closest('a[href^="#Image"]');
        if (!link || !navigation.contains(link)) return;
        // Never turn a thumbnail into a page anchor while the native slider loads.
        event.preventDefault();
        event.stopImmediatePropagation();
        const id = link.hash.slice(6);
        pendingNativeId = nativeSelect(id) ? null : id;
        queue();
      }, {capture: true});
      listen(navigation, 'keydown', event => {
        const link = event.target.closest?.('a[href^="#Image"]');
        if (!link) return;
        const current = thumbnails.indexOf(link);
        const index = event.key === 'ArrowLeft' ? current - 1 : event.key === 'ArrowRight' ? current + 1
          : event.key === 'Home' ? 0 : event.key === 'End' ? thumbnails.length - 1 : null;
        if (index === null) return;
        event.preventDefault();
        const target = thumbnails[Math.max(0, Math.min(index, thumbnails.length - 1))];
        reveal(target);
        target.focus({preventScroll: true});
        target.click();
      });
      listen(previous, 'click', () => scroll(navigation.scrollLeft - step()));
      listen(next, 'click', () => scroll(navigation.scrollLeft + step()));
      listen(navigation, 'scroll', updateArrows, {passive: true});
      listen(section, 'variant:changed', () => {
        // A new product configuration supersedes a queued image-only request.
        pendingNativeId = null;
        cancelAnimationFrame(breakpointFrame);
        queue();
      });
      const observer = new MutationObserver(queue);
      observer.observe(slideshow, {subtree: true, childList: true, attributes: true, attributeFilter: ['class']});
      const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(() => synchronize(true)) : null;
      if (resize) resize.observe(navigation);
      else listen(window, 'resize', () => synchronize(true), {passive: true});
      const onBreakpoint = () => {
        // Joquer and the mobile slider maintain separate active-image states.
        // Carry the visible choice across the breakpoint without changing variants.
        const id = pendingNativeId || lastId;
        cancelAnimationFrame(breakpointFrame);
        breakpointFrame = requestAnimationFrame(() => {
          if (destroyed) return;
          if (desktop.matches) {
            pendingNativeId = null;
            if (id) thumbnails.find(link => link.hash === '#Image' + id)?.click();
          } else if (id) {
            pendingNativeId = nativeSelect(id) ? null : id;
          }
          synchronize(true);
        });
      };
      if (desktop.addEventListener) listen(desktop, 'change', onBreakpoint);
      else { desktop.addListener(onBreakpoint); cleanups.push(() => desktop.removeListener(onBreakpoint)); }
      const cleanup = () => {
        destroyed = true;
        pendingNativeId = null;
        cancelAnimationFrame(breakpointFrame);
        observer.disconnect();
        resize?.disconnect();
        cancelAnimationFrame(frame);
        cleanups.forEach(fn => fn());
        // Restore the original DOM so editor reinitialization cannot leave a second rail.
        if (originalNavigation && originalParent) {
          const anchor = originalNextSibling?.parentNode === originalParent ? originalNextSibling : null;
          originalParent.insertBefore(originalNavigation, anchor);
          if (originalNavigationId === null) originalNavigation.removeAttribute('id');
          else originalNavigation.setAttribute('id', originalNavigationId);
          oldTabIndexes.forEach((value, link) => {
            if (value === null) link.removeAttribute('tabindex');
            else link.setAttribute('tabindex', value);
          });
        }
        rail.remove();
        section.removeAttribute('data-galea-four-thumbnails');
        instances.delete(section);
      };
      instances.set(section, cleanup);
      synchronize(true);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once: true});
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-galea-four-thumbnails]').forEach(section => instances.get(section)?.());
    if (event.target.matches?.('[data-galea-four-thumbnails]')) instances.get(event.target)?.();
  });
})();
